import {
  CategoryScale,
  ChartData,
  Chart as ChartJS,
  Filler,
  LineElement,
  LinearScale,
  PointElement,
  Tooltip
} from 'chart.js'
import { Line } from 'react-chartjs-2'

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip
)

export const options: any = {
  responsive: true,
  plugins: {
    legend: { display: false },
    datalabels: { display: false },
    tooltip: {
      enabled: false,
      external: (context: any) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const tooltip = context.tooltip
        let tooltipEl = document.getElementById('chart-tooltip')

        if (!tooltipEl) {
          tooltipEl = document.createElement('div')
          tooltipEl.id = 'chart-tooltip'
          tooltipEl.style.position = 'absolute'
          tooltipEl.style.background = 'white'
          tooltipEl.style.border = '1px solid #D2D2D2'
          tooltipEl.style.padding = '8px'
          tooltipEl.style.boxShadow = '0px 4px 6px rgba(0, 0, 0, 0.1)'
          tooltipEl.style.borderRadius = '4px'
          tooltipEl.style.pointerEvents = 'none'
          tooltipEl.style.whiteSpace = 'normal'
          tooltipEl.style.fontSize = '14px'
          tooltipEl.style.fontWeight = '700'
          tooltipEl.style.color = 'black'
          tooltipEl.style.textAlign = 'center'
          tooltipEl.style.zIndex = '9999'
          document.body.appendChild(tooltipEl)
        }

        if (tooltip.opacity === 0) {
          tooltipEl.style.opacity = '0'
          return
        }

        if (tooltip.body) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          const label = tooltip.dataPoints[0].raw || ''
          tooltipEl.innerHTML = `${label > 1 ? `${label.toLocaleString()} stickers` : `${label || '0'} sticker`},${tooltip.dataPoints[0].label}`
        }

        // Positioning
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const { x, y } = context.chart.canvas.getBoundingClientRect()
        const TOOLTIP_CENTER_DIVISOR = 2
        const TOOLTIP_OFFSET_ABOVE = 10
        const tooltipX =
          x + tooltip.caretX - tooltipEl.offsetWidth / TOOLTIP_CENTER_DIVISOR // Center tooltip
        const tooltipY =
          y + tooltip.caretY - tooltipEl.offsetHeight - TOOLTIP_OFFSET_ABOVE // Move tooltip above
        tooltipEl.style.left = `${tooltipX}px`
        tooltipEl.style.top = `${tooltipY}px`
        tooltipEl.style.opacity = '1'
      }
    }
  },
  maintainAspectRatio: false,
  layout: { autoPadding: true, padding: 0 },
  scales: {
    x: { display: false },
    y: { display: false }
  }
}

function AssessmentCumulativeTrendsChart({
  backgroundColor,
  lineColor,
  chartData,
  labels
}: {
  backgroundColor: string
  lineColor: string
  chartData: number[]
  labels: string[]
}) {
  const data: ChartData<'line', number[], string> = {
    labels,
    datasets: [
      {
        data: chartData,
        borderColor: lineColor,
        borderWidth: 2,
        backgroundColor,
        fill: {
          target: 'start',
          below: 'red'
        },
        pointRadius: 2,
        pointHitRadius: 10,
        pointBorderWidth: 0,
        pointBackgroundColor: '#F9BF34'
      }
    ]
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  return <Line options={options} data={data} />
}

export default AssessmentCumulativeTrendsChart
